"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var md5_1 = __importDefault(require("md5"));
exports.default = (function (virtual) { return function (frame) {
    var randomKey = frame.params ? frame.params.randomKey : undefined;
    if (!randomKey) {
        return;
    }
    var authKey = md5_1.default("" + randomKey + virtual.device.devTid + virtual.device.devPriKey);
    virtual.send('gatewayLogin', { authKey: authKey });
}; });



// WEBPACK FOOTER //
// ./src/actions/receive/actions/requestVerifyResp.ts